import { z } from 'zod'

// Schema for course (minimal)
const courseSchema = z.object({
  id: z.string(),
  title: z.string(),
  slug: z.string(),
  isPublished: z.boolean(),
})

// Schema for lesson (minimal, in hierarchy)
const lessonSchema = z.object({
  id: z.string(),
  title: z.string(),
  order: z.number(),
  moduleId: z.string(),
  isPublished: z.boolean(),
  // Optional progress fields (only if authenticated)
  isCompleted: z.boolean().optional(),
  isStarted: z.boolean().optional(),
})

// Schema for quiz (minimal, in hierarchy)
const quizSchema = z.object({
  id: z.string(),
  title: z.string(),
  passingScore: z.number(),
  maxAttempts: z.number(),
  isPublished: z.boolean(),
  // Optional progress field (only if authenticated)
  isPassed: z.boolean().optional(),
})

// Schema for module (in hierarchy)
const moduleSchema = z.object({
  id: z.string(),
  title: z.string(),
  order: z.number(),
  isPublished: z.boolean(),
  lessons: z.array(lessonSchema),
  quiz: quizSchema.nullable(),
})

// Schema for the course hierarchy API response (after apiClient extracts data.data)
export const courseHierarchyApiResponseSchema = z.object({
  course: courseSchema,
  modules: z.array(moduleSchema),
})

// Schema for the complete API response (before apiClient processing)
export const fullCourseHierarchyApiResponseSchema = z.object({
  success: z.boolean(),
  data: z.object({
    course: courseSchema,
    modules: z.array(moduleSchema),
  }),
  messages: z.array(z.string()).optional(),
  errors: z.array(z.string()).optional(),
})

export type CourseHierarchyApiResponse = z.infer<typeof courseHierarchyApiResponseSchema>
export type CourseHierarchy = z.infer<typeof courseSchema>
export type ModuleHierarchy = z.infer<typeof moduleSchema>
export type LessonHierarchy = z.infer<typeof lessonSchema>
export type QuizHierarchy = z.infer<typeof quizSchema>

